export { CategoryContainer as Category } from './container';
